<template>
  <v-data-table
    v-bind="$attrs"
    v-on="$listeners"
    class="boarua-table boarua-data-table"
  >
    <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotProps">
      <slot :name="name" v-bind="slotProps" />
    </template>

    <template v-if="!$scopedSlots.loading" v-slot:loading>
      <div class="table-loading-state">
        <v-progress-circular indeterminate color="primary" size="28" width="3" />
        <strong>{{ loadingTitle }}</strong>
        <span>{{ loadingDescription }}</span>
      </div>
    </template>

    <template v-if="!$scopedSlots['no-data'] && !$attrs['no-data-text']" v-slot:no-data>
      <div class="empty-state">
        <v-icon color="primary" size="34">{{ emptyIcon }}</v-icon>
        <strong>{{ emptyTitle }}</strong>
        <span>{{ emptyDescription }}</span>
      </div>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "BoaruaDataTable",
  inheritAttrs: false,
  props: {
    emptyIcon: {
      type: String,
      default: "mdi-table-search",
    },
    emptyTitle: {
      type: String,
      default: "Nenhum registro por enquanto",
    },
    emptyDescription: {
      type: String,
      default: "Quando houver dados deste módulo, eles aparecerão aqui.",
    },
    loadingTitle: {
      type: String,
      default: "Carregando itens",
    },
    loadingDescription: {
      type: String,
      default: "Aguarde enquanto buscamos os registros.",
    },
  },
};
</script>

<style lang="scss" scoped>
.boarua-data-table::v-deep {
  background: transparent !important;

  .v-data-table__wrapper {
    padding: 0;
  }

  table {
    border-spacing: 0;
    border-collapse: separate;
  }

  thead {
    background: #ffffff;
  }

  thead tr {
    height: 52px;
  }

  .v-data-table__progress th {
    height: 3px !important;
    padding: 0 !important;
    background: #ffffff !important;
    border-radius: 0 !important;
  }

  .v-data-table__progress .v-progress-linear {
    height: 3px !important;
    background: transparent !important;
  }

  .v-data-table__progress .v-progress-linear__background {
    background: transparent !important;
    opacity: 1 !important;
  }

  .v-data-table__progress .v-progress-linear__indeterminate {
    background: #057a3d !important;
  }

  th {
    height: 52px !important;
    padding: 0 18px !important;
    color: #111827 !important;
    border-bottom: 1px solid #d6ddd6 !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    letter-spacing: 0 !important;
    text-transform: uppercase !important;
  }

  th:first-child {
    border-top-left-radius: 8px;
  }

  th:last-child {
    border-top-right-radius: 8px;
  }

  th .v-icon {
    color: #66736b !important;
  }

  tbody tr {
    background: transparent !important;
    transition: background 0.16s ease;
  }

  tbody tr:hover {
    background: #ffffff !important;
  }

  tbody td {
    height: 58px !important;
    max-width: 340px;
    padding: 12px 18px !important;
    color: #263548;
    border-bottom: 1px solid #d6ddd6 !important;
    font-size: 13px;
    font-weight: 400;
    text-transform: none;
    vertical-align: middle;
  }

  tbody td:first-child {
    color: #10223f;
    font-weight: 400;
  }

  tbody td:last-child {
    text-align: right;
  }

  .v-data-table__empty-wrapper,
  .v-data-table__loading {
    height: 360px !important;
  }

  .v-data-table__empty-wrapper:hover,
  .v-data-table__loading:hover {
    background: transparent !important;
  }

  .v-data-table__empty-wrapper td,
  .v-data-table__loading td {
    height: 360px !important;
    padding: 0 !important;
    background: #ffffff !important;
    border-bottom: 0 !important;
  }

  .empty-state,
  .table-loading-state {
    min-height: 360px;
    width: 100%;
    display: grid;
    place-items: center;
    align-content: center;
    gap: 6px;
    background: #ffffff;
    text-align: center;

    strong {
      color: #10223f;
      font-size: 14px;
      font-weight: 900;
    }

    span {
      color: #66736b;
      font-size: 13px;
      font-weight: 700;
    }
  }

  .v-chip {
    height: 24px;
    border-radius: 999px;
    font-weight: 800;
  }

  .v-data-footer {
    min-height: 64px;
    margin-top: 0;
    padding: 10px 18px;
    background: #ffffff;
    border-top: 1px solid #d6ddd6;
  }
}
</style>
